/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Brief_ActionInputs */

const cs_templates_ai_brief_action = /** @type {(inputs: Templates_Ai_Brief_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navrhnout z briefu`)
};

const en_templates_ai_brief_action = /** @type {(inputs: Templates_Ai_Brief_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft from brief`)
};

/**
* | output |
* | --- |
* | "Draft from brief" |
*
* @param {Templates_Ai_Brief_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_brief_action = /** @type {((inputs?: Templates_Ai_Brief_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Brief_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_brief_action(inputs)
	return cs_templates_ai_brief_action(inputs)
});